import React, { useState, useRef, useEffect } from 'react';
import { FiX } from 'react-icons/fi';
import {
  Container,
  SelectContainer,
  SelectHeader,
  OptionList,
  OptionItem,
  ClearButton,
} from './styles';

interface Item {
  value: string;
  label: string;
}

interface Props {
  options: Item[];
  placeholder?: string;
  onChange?: (value: Item | null) => void;
  Title?: string;
}

const Producer: React.FC<Props> = ({
  options = [],
  placeholder = 'Selecione...',
  onChange,
  Title
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selected, setSelected] = useState<Item | null>(null);
  const ref = useRef<HTMLDivElement>(null);

  const toggleOpen = () => setIsOpen(prev => !prev);

  const handleSelect = (option: Item) => {
    setSelected(option);
    setIsOpen(false);
    onChange?.(option);
  };

  const handleClear = (e: React.MouseEvent) => {
    e.stopPropagation();
    setSelected(null);
    onChange?.(null);
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (ref.current && !ref.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <Container>
      <strong>{Title}</strong>
      <SelectContainer ref={ref}>
        <SelectHeader onClick={toggleOpen}>
          <span>{selected?.label || placeholder}</span>
          {selected && (
            <ClearButton onClick={handleClear}>
              <FiX />
            </ClearButton>
          )}
        </SelectHeader>
        {isOpen && (
          <OptionList>
            {options.length > 0 ? (
              options.map(option => (
                <OptionItem
                  key={option.value}
                  onClick={() => handleSelect(option)}
                >
                  {option.label}
                </OptionItem>
              ))
            ) : (
              <OptionItem key="no-value" onClick={handleClear}>
                Sem valor
              </OptionItem>
            )}
          </OptionList>
        )}
      </SelectContainer>
    </Container>
  );
};

export default Producer;
